import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { promoCodes } from 'src/constants'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title="Fubo Friends and Family Discount"
        offerCode={promoCodes.latino_special_offer}
        subtitle={
          <>
            {laChannelCount}+ channels of sports, news, novelas, and{' '}
            <span className="desktop-line-break">
              entertainment in Spanish - now only <span className="green-underline">$1.99</span> the
              first month!
            </span>{' '}
            Hurry, this offer won't last.
          </>
        }
        networkSet="entertainmentLatino"
        noteLink="/la/special-offer-es/"
        discountedPrice="1.99"
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      width: 110%;
      max-width: 1000px;

      box-sizing: border-box;
      background: rgba(3, 11, 24, 0.5);
      @media screen and (min-width: 768px) {
        background: linear-gradient(
          90deg,
          rgba(4, 9, 17, 0.95) 2%,
          rgba(3, 11, 24, 0.7) 50.36%,
          rgba(0, 15, 38, 0) 99.55%
        );
      }
    }
  }
`
